import { Component, OnInit } from '@angular/core';
import { HttpUtilService } from '@services/http-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { Location } from '@angular/common';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
  standalone: false,
})
export class DataListComponent implements OnInit {
  constructor(
    private httpUtils: HttpUtilService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location
  ) {}
  error = null;
  type = null;
  items = null;
  view = null;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.getDataList();
    });
  }

  private getDataList() {
    this.httpUtils
      .authGet(environment.apiRoot + '/' + this.type + '/select?mode=read')
      .pipe(catchError(error => of({ error })))
      .subscribe(data => {
        if (data?.error) {
          this.error = true;
        } else {
          this.error = null;
          this.view = data;
        }

        // if (data && data.listItems) {
        //     if (Array.isArray(data.listItems)){
        //         this.items = data.listItems;
        //     } else {
        //         this.items = [data.listItems]
        //     }
        // }
      });
  }

  editPage() {
    this.router.navigate(['edit'], { relativeTo: this.route });
  }

  back() {
    this._location.back();
  }

  home() {
    this.router.navigate(['/home']);
  }
}
